import type { SvgIconComponent } from '@mui/icons-material';
import type { JsonQuestion } from '@/components/questionnaires/json-driven/types';

export type QuestionnaireSourceType = 'core' | 'custom';
export type ShareActionIntent = 'copy-link' | 'fill-manually';

export interface QuestionnaireSectionGroup {
  id: string;
  label: string;
  shortCode: string;
  color: string;
  iconBg: string;
  iconColor: string;
  icon: SvgIconComponent;
  questions: JsonQuestion[];
}

export interface QuestionTypeChipStyle {
  bgcolor: string;
  color: string;
  borderColor: string;
}

export interface QuestionTypeChipData {
  type: JsonQuestion['type'];
  label: string;
  style: QuestionTypeChipStyle;
}

export const ACTIVE_SECTION_COLOR = '#28b3d5';
export const ACTIVE_SECTION_ROW_BG = 'rgba(40, 179, 213, 0.12)';
export const ACTIVE_SECTION_ICON_BG = '#dff5fb';
export const ACTIVE_SECTION_ICON_COLOR = '#1699c8';
export const ADDITIONAL_QUESTIONS_SECTION_ID = 'additional-questions';
export const ADDITIONAL_QUESTIONS_HASH = `#${ADDITIONAL_QUESTIONS_SECTION_ID}`;
